import { CheckChoicesModalComponent } from './check-choices-modal.component';

export default angular
  .module('sfMobile.components.check-choices-modal', [
    'sfMobile.components.button-header-close',
    'sfMobile.components.input-checkbox-item',
    'sfMobile.components.input-checkbox-item-free',
  ])
  .component('sfCheckChoicesModal', CheckChoicesModalComponent).name;
